export default __webpack_public_path__ + "static/media/Contrato-Social-de-Sociedade-de-Advogados.df0752e2.docx";